import { useNavigate } from "react-router-dom";
import { FiArrowLeft, FiInfo } from "react-icons/fi";
import Sidebar from "../../components/Sidebar/Sidebar";
import Header from "../../components/Header/Header";
import "./LegalPages.css";

export default function PrivacyPolicy() {
  const navigate = useNavigate();

  return (
    <div className="layout">
      <Sidebar />
      <div className="content">
        <Header />
        <div className="lgl-page">
          <button className="lgl-back-btn" onClick={() => navigate(-1)}>
            <FiArrowLeft size={14} /> Back
          </button>

          <div className="lgl-card">
            <div className="lgl-card-header">
              <FiInfo size={16} />
              <h2>Privacy Policy</h2>
            </div>

            <div className="lgl-text">
              <p>
                This page describes how FleetManagementPro collects, uses, and protects
                your personal data. Replace this placeholder with your actual
                privacy policy content, or fetch it from your CMS / backend.
              </p>
              <h3>Information We Collect</h3>
              <p>
                Account details such as your name, email address, and mobile
                number, along with usage data needed to operate the service.
              </p>
              <h3>How We Use Your Information</h3>
              <p>
                To provide and improve the service, communicate with you, and
                meet legal and security obligations.
              </p>
              <h3>Contact</h3>
              <p>
                For privacy-related questions, reach out via the support
                details listed on the Settings page.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}